import React from 'react'
import { Button, Typography, theme } from 'antd'
import { PlusOutlined, BellOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const RemindersHeader = ({ onCreateReminder }) => {
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <BellOutlined style={{ marginRight: '12px', fontSize: '28px' }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Staff Reminders
        </Title>
      </div>
      <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
        <Button
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          onClick={onCreateReminder}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Create Reminder
        </Button>
      </div>
    </div>
  )
}

export default RemindersHeader
